import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, ReqX, ZMath, ZTime, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { ActivityIndicator, HStack, Spacer, VStack, XButton, XScroll, XText } from "IZOX/_X";
import Options from "shared/Options";
import _ from "lodash";
import { QForm } from "IZOX/BLOCKS/Libs";
import { QFDropUpload, QFRadio, QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import PolicyRow from "shared/PolicyRow";
import QUICKUI from "shared/QUICKUI";
import ReceiptRow from "shared/ReceiptRow";
import VarList from "shared/VarList";
import Styles from "__SYSDefault/Styles";

/**
 * @augments {Component<Props, State>}
 */
class ViewPolicy extends Component {

  static propTypes = {
    docID: PropsType.string
  }

  static defaultProps = {
    docID: ""
  }

  constructor(){
    super();
    this.state = {
      step: 0,
      showPolicyDetails: false,
      changeAddress: false,
      changeHelper: false,
      addressForm: {},
      helperForm: {
        _newMaid: false
      },
      loading: false
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetNationalityList();
      this.GetDoc();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ViewPolicy.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  validateHelperChangeForm = () => {
    let {helperForm} = this.state;
    let valid = ZValidate.CheckAllFields(helperForm, 
      [
        "m_fullName", "m_dateOfBirth", 
        "m_gender", "m_passport", "m_nationality"
      ],
      ["required"]);
    return valid;
  }

  GetDoc = async () => {
    this.setState({
      loading: true
    }, async () => {
      let {docID} = this.props; 
      let res = await ReqX.SendBE("/Web/Insurer/ViewPolicy", {
        docID
      });
      let {Success, payload} = res;
      if(Success){
        this.setState({
          policyDoc: payload,
          loading: false
        });
      }
    });
  }

  GetNationalityList = async () => {
    let docs = await VarList.GetFullList("Nationality");
    this.setState({
      nationalities: docs
    });
  }

  _toView = () => {
    this.setState({
      step: 0
    }, () => {
      this.GetDoc();
    });
  }

  _close = () => {
    let {Refresh} = this.props;
    Refresh?.();
    GFunc.CloseBackdrop();
  }

  _toSuccess = () => {
    this.setState({
      step: 1
    });
  }

  _onChangeHelperForm = (formValue) => {
    this.setState({
      helperForm: formValue
    });
  }

  _cancelHelperChange = () => {
    this.setState({
      changeHelper: false,
      helperForm: {
        _newMaid: false
      }
    });
  }

  _onChangeAddressForm = (formValue) => {
    this.setState({
      addressForm: formValue
    });
  }

  _cancelAddressChange = () => {
    this.setState({
      changeAddress: false,
      addressForm: {}
    });
  }

  _submitAddressChange = async () => {
    let {policyDoc} = this.state;
    let {addressForm} = this.state;
    let res = await ReqX.SendBE("/Web/Agent/SubmitAddressChange", {
      docID: policyDoc._id,
      addressForm
    });
    let {Success, payload} = res;
    if(Success){
      this._toSuccess();
      this._cancelAddressChange();
    }else{
      GFunc.Alert(payload, "error");
    }
  }

  GetMaids = async () => {
    let res = await ReqX.SendBE("/Web/Agent/GetMaids");
    let {Success, payload} = res;
    if(Success){
      this.setState({
        oldMaids: payload
      });
    }
  }

  toToggleDetails = () => {
    let {showPolicyDetails} = this.state;
    this.setState({
      showPolicyDetails: !showPolicyDetails
    });
  }

  _selectOldMaid = (maidID) => {
    let {helperForm, oldMaids} = this.state;
    let maidDoc = _.find(oldMaids, o => o._id === maidID);
    helperForm = {
      _newMaid: false,
      existingMaid: maidID,
      m_fullName: maidDoc?.fullName,
      m_dateOfBirth: maidDoc?.dateOfBirth,
      m_gender: maidDoc?.gender,
      m_passport: maidDoc?.passport,
      m_nationality: maidDoc?.nationality
    };
    this.setState({
      helperForm: helperForm
    });
  }

  renderTextPreview(label, value, width = 320, inject = null){
    return (
      <VStack width={width}>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={14} color={ColorX.CSS("Gray4")}>
            {LocaleX.Parse(label)}
          </XText>
          {inject}
        </HStack>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={14} color={ColorX.CSS("Stone")}>
            {LocaleX.Parse(value)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderWaitingApproval(){
    return (
      <HStack HAlign="[" pH={10} fitWidthToContent>
        <XText color={ColorX.CSS("ExpireSoon")} fontSize={14}>
          {LocaleX.Parse({
            EN: "Waiting for approval",
            TC: "等待批准"
          })}
        </XText>
      </HStack>
    );
  }

  renderPreviewCIDC(){
    let {policyDoc} = this.state;
    let {_dCustomer} = policyDoc ?? {};
    let {workingAddress} = policyDoc ?? {};
    let {fullName, gender, disHKID, primaryAddress, additionalAddress} = _dCustomer?.meta ?? {};
    let {telNo, email} = _dCustomer ?? {};
    return (
      <VStack fullWidth pB={4} pH={16}>
        {QUICKUI.BoxTitle({
          EN: "Client's Information",
          TC: "客戶資料"
        }, "Leaf")}
        <VStack fullWidth HAlign="[" pV={10} spacing={10} pH={16}
          bgColor={ColorX.CSS("pureWhite")}
          bColor={ColorX.CSS("Leaf")} bW={2}>
          <HStack HAlign="[">
            {QUICKUI.TextPreview(
              {EN: "Full name", TC: "姓名"},
              fullName?.EN ?? "NULL"
            )}
            {QUICKUI.TextPreview(
              {EN: "Full name (Chinese name)", TC: "姓名(中文)"},
              fullName?.TC ?? "NULL"
            )}
          </HStack>
          <HStack HAlign="[">
            {QUICKUI.TextPreview(
              {EN: "Email", TC: "電郵"},
              email ?? "NULL"
            )}
            {QUICKUI.TextPreview(
              {EN: "Gender", TC: "性別"},
              Options.GetOption("Gender", gender)?.cap ?? "NULL"
            )}
          </HStack>
          <HStack HAlign="[">
            {QUICKUI.TextPreview(
              {EN: "HKID number", TC: "香港身份證號碼"},
              disHKID ?? "NULL"
            )}
            {QUICKUI.TextPreview(
              {EN: "Mobile phone", TC: "手機號碼"},
              telNo ? `+852 ${telNo}` : "NULL"
            )}
          </HStack>
          <HStack>
            {this.renderTextPreview(
              {EN: "Address (English)", TC: "地址 (英文)"},
              primaryAddress?.EN ?? "NULL",
              "50%"
            )}
            {this.renderTextPreview(
              {EN: "Address (Chinese)", TC: "地址 (中文)"},
              primaryAddress?.TC ?? "NULL",
              "50%"
            )}
          </HStack>
          {_.map(additionalAddress, (o, i) => {
            return (
              <HStack key={i}>
                {QUICKUI.TextPreview(
                  {
                    EN: `Additional Address #${i+1}`,
                    TC: `附加地址 #${i+1}`
                  },
                  `${additionalAddress?.[i]?.EN}` ?? "NULL",
                  "50%"
                )}
                {QUICKUI.TextPreview(
                  {
                    EN: "(Chinese)",
                    TC: "(中文)"
                  },
                  `${additionalAddress?.[i]?.TC}` ?? "NULL",
                  "50%"
                )}
              </HStack>
            );
          })}
          <HStack HAlign="[">
            {QUICKUI.TextPreview(
              {EN: "Working Address", TC: "工作地址"},
              (workingAddress?.EN) ?? "NULL",
              "50%")}
            {QUICKUI.TextPreview(
              {EN: "(Chinese)", TC: "(中文)"},
              (workingAddress?.TC) ?? "NULL",
              "50%", {}, {}
            )}
          </HStack>
        </VStack>
      </VStack>
    );
  }

  renderPreviewCIAgent(){
    let {policyDoc} = this.state;
    let {_client} = policyDoc ?? {};
    let {workingAddress} = policyDoc ?? {};
    let {meta, telNo, email} = _client ?? {};
    let {fullName, gender, disHKID, primaryAddress, additionalAddress} = meta ?? {};
    return (
      <VStack fullWidth pB={4} pH={16}>
        {QUICKUI.BoxTitle({
          EN: "Client's Information",
          TC: "客戶資料"
        }, "Leaf")}
        <VStack fullWidth HAlign="[" pV={10} spacing={10} pH={16}
          bgColor={ColorX.CSS("pureWhite")}
          bColor={ColorX.CSS("Leaf")} bW={2}>
          <HStack HAlign="[">
            {QUICKUI.TextPreview(
              {EN: "Full name", TC: "姓名"},
              fullName?.EN ?? "NULL"
            )}
            {QUICKUI.TextPreview(
              {EN: "Full name (Chinese name)", TC: "姓名(中文)"},
              fullName?.TC ?? "NULL"
            )}
          </HStack>
          <HStack HAlign="[">
            {QUICKUI.TextPreview(
              {EN: "Email", TC: "電郵"},
              email ?? "NULL"
            )}
            {QUICKUI.TextPreview(
              {EN: "Gender", TC: "性別"},
              Options.GetOption("Gender", gender)?.cap ?? "NULL"
            )}
          </HStack>
          <HStack HAlign="[">
            {QUICKUI.TextPreview(
              {EN: "HKID number", TC: "香港身份證號碼"},
              disHKID ?? "NULL"
            )}
            {QUICKUI.TextPreview(
              {EN: "Mobile phone", TC: "手機號碼"},
              telNo ? `+852 ${telNo}` : "NULL"
            )}
          </HStack>
          <HStack>
            {this.renderTextPreview(
              {EN: "Address (English)", TC: "地址 (英文)"},
              primaryAddress?.EN ?? "NULL",
              "50%"
            )}
            {this.renderTextPreview(
              {EN: "Address (Chinese)", TC: "地址 (中文)"},
              primaryAddress?.TC ?? "NULL",
              "50%"
            )}
          </HStack>
          {_.map(additionalAddress, (o, i) => {
            return (
              <HStack key={i}>
                {QUICKUI.TextPreview(
                  {
                    EN: `Additional Address #${i+1}`,
                    TC: `附加地址 #${i+1}`
                  },
                  `${additionalAddress?.[i]?.EN}` ?? "NULL",
                  "50%"
                )}
                {QUICKUI.TextPreview(
                  {
                    EN: "(Chinese)",
                    TC: "(中文)"
                  },
                  `${additionalAddress?.[i]?.TC}` ?? "NULL",
                  "50%"
                )}
              </HStack>
            );
          })}
          <HStack HAlign="[">
            {QUICKUI.TextPreview(
              {EN: "Working Address", TC: "工作地址"},
              (workingAddress?.EN) ?? "NULL",
              "50%")}
            {QUICKUI.TextPreview(
              {EN: "(Chinese)", TC: "(中文)"},
              (workingAddress?.TC) ?? "NULL",
              "50%", {}, {}
            )}
          </HStack>
        </VStack>
      </VStack>
    );
  }

  renderPreviewCI(){
    let {policyDoc} = this.state;
    let {fromAgent} = policyDoc ?? {};
    if(fromAgent) return this.renderPreviewCIAgent();
    else return this.renderPreviewCIDC();
  }

  renderPreviewInsured(o){
    let {nationalities} = this.state;
    let {fullName, dateOfBirth, gender, passport, nationality} = o ?? {};
    let _gender = Options.GetOption("Gender", gender);
    let _nationality = VarList.GetOption(nationalities, nationality)?.name ?? "NULL";
    
    return (
      <VStack fullWidth pB={4} pH={16}>
        <VStack bW={2} bColor={ColorX.CSS("Leaf")} fullWidth>
          {QUICKUI.BoxTitle({
            EN: "Domestic Helper",
            TC: "家務助理",
          }, "Leaf")}
          <VStack fullWidth pH={16} pV={16} bgColor={ColorX.CSS("pureWhite")} spacing={10}>
            <HStack HAlign="[">
              {QUICKUI.TextPreview(
                {EN: "Domestic Helper's name", TC: "家務助理姓名"},
                fullName ?? "NULL",
                "100%", {}, {})}
            </HStack>
            <HStack spacing={16} HAlign="[">
              {QUICKUI.TextPreview(
                {
                  EN: "Date of birth",
                  TC: "出生日期"
                },
                dateOfBirth ? ZTime.Moment(dateOfBirth).format("DD/MM/YYYY") 
                  : "NULL")}
              {QUICKUI.TextPreview(
                {
                  EN: "Gender",
                  TC: "性別"
                },
                LocaleX.Parse(_gender?.cap ?? "NULL"))}
            </HStack>
            <HStack spacing={16} HAlign="[">
              {QUICKUI.TextPreview(
                {EN: "Passport number / HKID", TC: "護照 / 香港身份證號碼"},
                passport ?? "NULL")}
              {QUICKUI.TextPreview(
                {
                  EN: "Nationality",
                      TC: "國籍"
                },
                LocaleX.Parse(_nationality ?? "NULL"))}
            </HStack>
          </VStack>
        </VStack>
      </VStack>
    );
  }

  renderPreviewInurance(){
    return this.renderInsurance(true);
  }

  renderYesNoQuestions(question, name){
    return (
      <HStack pV={10} spacing={10} HAlign="[">
        <HStack width={300} pH={10} HAlign="[">
          <XText fontSize={14}
            color={ColorX.CSS("Stone")} 
            textAlign="[">
            {LocaleX.Parse(question)}
          </XText>
        </HStack>
        <HStack width={170} spacing={5} HAlign="[">
          <QFRadio name={name} refValue={true}/>
          <XText color={ColorX.CSS("Leaf")}>
            {LocaleX.Parse({
              EN: "Yes",
              TC: "是"
            })}
          </XText>
        </HStack>
        <HStack width={170} spacing={5} HAlign="[">
          <QFRadio name={name} refValue={false} 
            bColor={ColorX.CSS("Blood")}/>
          <XText color={ColorX.CSS("Blood")}>
            {LocaleX.Parse({
              EN: "No",
              TC: "否"
            })}
          </XText>
        </HStack>
      </HStack>
    );
  }

  renderPackage(pack, idx){
    let {_id, name, duration} = pack;
    let y1 = _.find(duration, o => o.year === 1);
    let y2 = _.find(duration, o => o.year === 2);
    return (
      <HStack pV={10} key={idx}>
        <HStack width={224} pH={10}>
          <XText fontSize={14}
            color={ColorX.CSS("Stone")} 
            textAlign="[">
            {LocaleX.Parse(name)}
          </XText>
        </HStack>
        <HStack width={224} spacing={5} HAlign="[">
          <QFRadio name="_package" refValue={`${_id}_1`}/>
          <XText color={ColorX.CSS("Leaf")}>
            {"HK$" + ZMath.NumberWithCommas(y1?.price)}
          </XText>
        </HStack>
        <HStack width={224} spacing={5} HAlign="[">
          <QFRadio name="_package" refValue={`${_id}_2`}/>
          <XText color={ColorX.CSS("Leaf")}>
            {"HK$" + ZMath.NumberWithCommas(y2?.price)}
          </XText>
        </HStack>
      </HStack>
    );
  }

  renderInsurance(readOnly = false){
    let {policyDoc} = this.state;
    let {packageDoc, policyDuration, totalAmount, receiptPrice} = policyDoc ?? {};
    return (
      <QForm fullWidth value={policyDoc} readOnly={readOnly} p={16}>
        <XScroll height={readOnly ? "auto" : 600} pH={16} overflow={readOnly ? "visible" : "auto"}>
          <HStack HAlign="[">
            <XText bold color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Package",
                TC: "套餐"
              })}
            </XText>
          </HStack>
          <HStack>
            <XText width={"70%"}>
              {LocaleX.Parse(packageDoc?.name)}
            </XText>
            <Spacer/>
            <XText>
              {LocaleX.Parse({
                EN: policyDuration + (policyDuration === 1 ? " year" : " years"),
                TC: policyDuration + "年"
              })}
            </XText>
          </HStack>
          <VStack fullWidth>
            <HStack pV={10}>
              <XText>
                {LocaleX.Parse({
                  EN: "Total",
                  TC: "總額"
                })}
              </XText>
              <Spacer/>
              <XText>
                {"HK$" + ZMath.NumberWithCommas(totalAmount)}
              </XText>
            </HStack>
            {receiptPrice > 0
              && 
              <HStack pV={10}>
                <XText>
                  {LocaleX.Parse({
                    EN: "Receipt Price (HK$)",
                    TC: "收據價格 (HK$)"
                  })}
                </XText>
                <Spacer/>
                <XText>
                  {"HK$" + ZMath.NumberWithCommas(receiptPrice)}
                </XText>
              </HStack>}
          </VStack>
          <VStack pV={16}>
            <HStack HAlign="[">
              <XText bold color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Others",
                  TC: "其他"
                })}
              </XText>
            </HStack>
            <HStack>
              <XText color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Included the Government Levy, Government Terrorism Facility Charge and Employees' Compensation Insurer Insolvency Bureau Contribution",
                  TC: "包括政府徵費、政府恐怖主義融資費用和員工賠償保險公司破產局繳款"
                })}
              </XText>
            </HStack>
          </VStack>
          <VStack fullWidth bgColor={ColorX.CSS("pureWhite")}>
            <HStack bgColor={ColorX.CSS("ActiveBg")} p={10} HAlign="[">
              <XText bold fontSize={14}
                color={ColorX.CSS("Active")} 
                textAlign="[" width={224}>
                {LocaleX.Parse({
                  EN: "Questionnaires",
                  TC: "問卷調查"
                })}
              </XText>
            </HStack>
            <HStack p={10}>
              <XText fontSize={14}
                color={ColorX.CSS("Stone")} 
                textAlign="[">
                {LocaleX.Parse({
                  EN: "Helper's Monthly Salary:",
                  TC: "助理月薪"
                })}
              </XText>
              <Spacer/>
              <QFText
                isError={({field}) => !field || field <= 0}
                name="others.questions.salary"
                type="number"
                placeholder={LocaleX.Parse({
                  EN: "Enter amount",
                  TC: "輸入金額"
                })}
                width={157}
                p={12}
                focus_bColor={ColorX.CSS("Axit")}
                bColor={ColorX.CSS("Gray5")}
              />
            </HStack>
            {this.renderYesNoQuestions({
              EN: "Is your domestic helper receiving or contemplating any medical attention or surgical treatment or taking any medicine?",
              TC: "您的家庭傭工是否正在接受或考慮接受任何醫療護理或手術治療或服用任何藥物？"
            }, "others.questions.medical")}
            <HStack HAlign="[" p={10}>
              {QUICKUI.WebTextField("others.questions.medicalinfo", 
                {
                  EN: "If any of the above answer is \"Yes\", please provide full details",
                  TC: "如果以上任何一個答案為\"是\"，請提供完整的詳細資訊"
                }, {width: "100%", multilines: true, height: 100})}
            </HStack>
            <HStack HAlign="[" p={10}>
              {this.renderYesNoQuestions({
                  EN: "Have you ever been refused for application or renewal of, or requested for cancellation of domestic helper insurance by any insurance company or subject to special terms and conditions?",
                  TC: "您是否曾被任何保險公司拒絕申請、續保、或要求取消家庭傭工保險，或受特別條款及細則約束？"
                }, "others.questions.reject")}
            </HStack>
            <HStack HAlign="[" p={10}>
              {QUICKUI.WebTextField("others.questions.history", 
                {
                  EN: "If any of the above answer is \"Yes\", please provide full details",
                  TC: "如果以上任何一個答案為\"是\"，請提供完整的詳細資訊"
                }, {width: "100%", multilines: true, height: 100})}
            </HStack>
            <HStack HAlign="[" p={10}>
              {this.renderYesNoQuestions({
                  EN: "Has your domestic helper confined in hospital for surgery or treatment of sickness or injury resulting from an accident in the past 3 years?",
                  TC: "過去3年，你的家庭傭工是否曾因意外而生病或受傷而住院接受手術或治療？"
                }, "others.questions.hospital")}
            </HStack>
          </VStack>
        </XScroll>
      </QForm>
    );
  }

  renderPolicyDoc(){
    let {policyDoc} = this.state;
    if(!policyDoc) return;
    return (
      <VStack fullWidth pH={16}>
        <PolicyRow policyDoc={policyDoc} 
          onViewDetailPress={this.toToggleDetails}/>
      </VStack>
    );
  }

  renderSuppDocs(){
    let {policyDoc} = this.state;
    let {_supps} = policyDoc ?? {}; 
    let attachments = [];
    _.map(_supps, (o, i) => {
      _.map(o.attachments, (v, x) => {
        attachments.push(v);
      });
    });
    return (
      <VStack fullWidth p={16}>
        <HStack HAlign="[" bgColor={ColorX.CSS("Leaf")} pH={16} pV={8}>
          <XText textAlign="[" color={ColorX.CSS("pureWhite")} bold>
            {LocaleX.Parse({
              EN: `Documents (${attachments?.length ?? 0})`,
              TC: `文件 (${attachments?.length ?? 0})`,
            })}
          </XText>
        </HStack>
        <QForm value={{attachments: attachments}} fullWidth>
          <QFDropUpload 
            btnBgColor={ColorX.CSS("Axit")}
            color={ColorX.CSS("Stone")}
            previewColor={ColorX.CSS("Leaf")}
            fileSizeLimit={10}
            name="attachments"
            accept=".jpg,.png,.pdf,.jpeg"
            fullWidth
            instantUpload
            multiple
            readOnly
            noFileCaption
            previewZoneProps={{fullWidth: true, pV: 5, pH: 16}}/>
        </QForm>
      </VStack>
    );
  }

  renderReceipts(){
    let {policyDoc} = this.state;
    let {_receipt} = policyDoc ?? {}; 
    return (
      <VStack fullWidth p={16}>
        <HStack HAlign="[" bgColor={ColorX.CSS("Leaf")} pH={16} pV={8}>
          <XText textAlign="[" color={ColorX.CSS("pureWhite")} bold>
            {LocaleX.Parse({
              EN: "Receipts",
              TC: "收據",
            })}
          </XText>
        </HStack>
        <ReceiptRow doc={_receipt}/>
      </VStack>
    );
  }

  renderView(){
    let {showPolicyDetails} = this.state;
    let {policyDoc} = this.state;
    let {_maid} = policyDoc ?? {}; 
    return (
      <XScroll height={600} fullWidth pV={20}>
        {this.renderPreviewCI()}
        <VStack fullWidth>
          {this.renderPreviewInsured(_maid)}
        </VStack>
        {this.renderPolicyDoc()}
        {showPolicyDetails && this.renderPreviewInurance()}
        {this.renderSuppDocs()}
        {this.renderReceipts()}
      </XScroll>
    );
  }

  renderSubmitChangeSuccess(){
    return (
      <VStack fullWidth spacing={16} pT={30}>
        <VStack fullWidth fitHeightToContent spacing={30}>
          <HStack pH={16}>
            <XText fontSize={28} color={ColorX.CSS("Leaf")} bold>
              {LocaleX.Parse({
                EN: "Submitted Change Successfully",
                TC: "提交改動成功"
              })}
            </XText>
          </HStack>
          <HStack pH={16}>
            <XText fontSize={14} color={ColorX.CSS("Stone")} bold>
              {LocaleX.Parse({
                EN: "It will take 3-4 weeks to provide a  result or progress update.",
                TC: "需要 3-4 週才能提供結果或進度更新。"
              })}
            </XText>
          </HStack>
          <HStack>
            <XButton {...Styles.QFBtn} width={200} onPress={this._toView}
              padding={0} pV={8}>
              <HStack>
                <XText bold>
                  {LocaleX.Parse({
                    EN: "Back to Details",
                    TC: "返回資料"
                  })}
                </XText>
              </HStack>
            </XButton>
          </HStack>
        </VStack>
        <HStack spacing={16} 
          style={{
            borderTopWidth: 1, 
            borderTopStyle: "solid",
            borderTopColor: ColorX.CSS("greyOut", 0.3)
          }} 
          HAlign="]" pH={16}>
          <XButton fitWidthToContent onPress={this._close}
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Close",
                  TC: "關閉"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>        
      </VStack>
    );
  }

  renderMain(){
    let {step, loading} = this.state;
    if(loading) return (
      <VStack fullWidth height={600} VAlign="-">
        <ActivityIndicator loading={true}/>
      </VStack>
    );
    switch(step){
      default: case 0: return this.renderView();
      case 1: return this.renderSubmitChangeSuccess();
    }
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("NotQuiteWhite")}
        width={845}>
        {QUICKUI.PopupTitleBar({
          EN: "Policy Details",
          TC: "保單詳細資料"
        }, this._close)}
        {this.renderMain()}
      </VStack>
    );
  }

}

export default observer(ViewPolicy);
